/**
 * @generated SignedSource<<faa5fb6e1c6ebfa248bc3efb18b6bf05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InsertTemplateList_project$data = {
  readonly baselineTemplatesForInsert: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null;
    readonly description: string | null;
    readonly phaseCount: number | null;
    readonly totalMinutes: number | null;
    readonly roleCount: number | null;
    readonly durationDays: number | null;
    readonly includeDeliverables: boolean | null;
    readonly deliverableCount: number | null;
  } | null> | null;
  readonly " $fragmentType": "InsertTemplateList_project";
};
export type InsertTemplateList_project$key = {
  readonly " $data"?: InsertTemplateList_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"InsertTemplateList_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InsertTemplateList_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BaselineTemplate",
      "kind": "LinkedField",
      "name": "baselineTemplatesForInsert",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phaseCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "roleCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "durationDays",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "includeDeliverables",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deliverableCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};

(node as any).hash = "83ae269802ef1341ad61129928a78cb7";

export default node;
